<template>
  <button @click="handleClick"
          class="button"
          :class="icon">
    <slot></slot>
  </button>
</template>

<script>
  export default {
    props: {
      icon: null,
    },
    methods: {
        handleClick(e) {
            this.$emit('click', e);
        }
    }
  }
</script>

<style scoped lang="less">

  button {
    position: relative;

    padding: var(--margin--tiny) var(--margin--small);

    color: var(--color-main);
    font-size: 16px;

    background-color: transparent;
    border: 2px solid var(--color-main);
    border-right-color: var(--color-main--darker);
    border-top-color: var(--color-main--darker);
    border-radius: 2px;
    outline: none;

    transition: 0.25s ease;

    &:hover:not(:disabled) {
      color: white;

      border-color: var(--color-hover);
      background: var(--color-hover);
      box-shadow: 0 6px 15px 0 rgba(0, 0, 0, 0.15);
      cursor: pointer;
    }

    &:disabled {
      color: var(--color-grey);
      background-color: var(--color-separation-border);
      border-color: var(--color-separation-border);
      cursor: not-allowed;
    }

    &[primary] {
      color: white;

      background-color: var(--color-main);
      border-color: var(--color-main--darker);
    }

    &[outline] {
      border-color: transparent;
    }
  }


</style>
